"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxPropTypes = void 0;

var _propTypes = require("prop-types");

var CheckboxPropTypes = {
  PropTypes: {
    isSelected: _propTypes.bool,
    onChange: _propTypes.func,
    text: _propTypes.string,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    disableCheckbox: _propTypes.bool,
    disableBottomMargin: _propTypes.bool,
    isFullWidth: _propTypes.bool,
    textCustomProperties: _propTypes.object,
    disabledWithSelected: _propTypes.bool,
    disableAlignment: _propTypes.bool,
    icon: _propTypes.string,
    iconCustomProperties: _propTypes.object,
    boldText: _propTypes.bool,
    value: _propTypes.string,
    borderColor: _propTypes.string
  },
  DefaultProps: {
    isSelected: false,
    onChange: function onChange() {},
    text: '',
    theme: '',
    accessible: true,
    disableCheckbox: false,
    disableBottomMargin: false,
    isFullWidth: false,
    disabledWithSelected: false,
    disableAlignment: false,
    boldText: false
  }
};
exports.CheckboxPropTypes = CheckboxPropTypes;